
import { Vue, Component, Prop } from 'vue-property-decorator';
import WorkbenchesService from '@/services/workbenches.service';
import lazyInject from '@/di';
import * as echarts from 'echarts';

@Component({})
export default class PriceTrendModal extends Vue {
  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;
  @Prop()
  reportData: any;

  validItem: any = {};

  buyText = {
    dealerBuy: '车商收购',
    dealerRetail: '车商零售',
    personalTrade: '个人交易',
  };

  conditionText = {
    good: '车况良好',
    excellent: '车况完好',
    normal: '车况一般',
  };

  buyTexts = ['dealerBuy', 'personalTrade', 'dealerRetail'];

  visible = false;
  title = '';
  width = 500;
  height = 500;
  footer = null;
  data: any = [];
  async init(value: any) {
    console.log(value);
    this.visible = true;
    this.title = '价格趋势图';
    this.width = 1000;
    this.height = 800;
    this.footer = null;
    const { defaultCondition, evalInfo } = this.reportData;
    const validItems = evalInfo.find(
      (item: any) => item.condition == defaultCondition,
    );
    this.validItem = validItems;
    this.data = validItems.futureTrends.trends;
    this.$nextTick(() => {
      this.initEcharts();
    });
  }

  choiceInfo(item: any) {
    console.log(item);
    this.validItem = item;
    this.data = item.futureTrends.trends;
    this.initEcharts();
  }

  funCost(cost: any) {
    if (cost === undefined) {
      return '';
    }
    return cost;
  }

  getValidItems(item: any, type: any) {
    if (item) {
      return item[type];
    }
    return '';
  }

  handleCancel() {
    this.visible = false;
  }
  initEcharts() {
    console.log(this.data);
    const data = this.data.map((item: any) => item.date);
    const consumption = this.data.map((item: any) => item.prices.dealerBuy);
    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
      },
      xAxis: {
        type: 'category',
        data,
        axisLabel: {
          rotate: 30, // 倾斜角度，0-90度
          margin: 10, // 标签与轴线的距离
          interval: 0, // 强制显示所有标签
          // 其他样式设置
          color: '#666',
          fontSize: 10,
        },
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          name: '价格趋势（万元）',
          data: consumption,
          type: 'line',
        },
      ],
    };
    console.log(option);
    const chart: any = document.getElementById('echart-container');
    const myChart = echarts.init(chart);
    myChart.setOption(option);
  }
}
